import { render, staticRenderFns } from "./TabSimulationMaterial.vue?vue&type=template&id=d7baae7a"
import script from "./TabSimulationMaterial.vue?vue&type=script&lang=js"
export * from "./TabSimulationMaterial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports